/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursaevents.EventSource
*/
export var EventSource;
(function (EventSource) {
    EventSource["PROJECT"] = "PROJECT";
    EventSource["TENANT"] = "TENANT";
})(EventSource || (EventSource = {}));
//# sourceMappingURL=EventSource.js.map